/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const isProduction = window.location.hostname !== "localhost";

Sentry.init({
  dsn: "https://182093a2646abd8f6dd75d1d08459b78@o4511449762430976.ingest.us.sentry.io/4511449776062464",
  environment: isProduction ? "production" : "development",
  tracesSampleRate: isProduction ? 0.1 : 1.0,
  integrations: [Sentry.browserTracingIntegration()],
});

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
